// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iW5e1i {
  display: flex;
  align-items: center;
  gap: var(--spacing-1, 8px);
  cursor: pointer;
  font-family: var(--font-family-base);
}

.iW5e1i.UMwjtk {
  cursor: not-allowed;
  opacity: var(--checkbox-disabled-opacity, 0.6);
}

.jQygNX {
  align-items: center;
  display: flex;
  height: 16px;
  justify-content: center;
  position: relative;
  width: 16px;
}

.hCNOVB {
  width: 16px;
  height: 16px;
  appearance: none;
  border: 1px solid var(--checkbox-border);
  border-radius: var(--checkbox-border-radius);
  background-color: var(--checkbox-background);
  cursor: pointer;
  position: relative;
}

.hCNOVB:checked {
  background-color: var(--checkbox-checked-background);
  border-color: var(--checkbox-checked-border);
}

.VjAoa2 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: var(--checkbox-checked-icon-color);
  display: none;
  pointer-events: none;
}

.hCNOVB:checked ~ .VjAoa2 {
  display: block;
}

.hCNOVB:disabled {
  cursor: not-allowed;
  opacity: var(--checkbox-disabled-opacity, 0.6);
}

.hCNOVB:indeterminate {
  background-color: var(--checkbox-checked-background);
  border-color: var(--checkbox-checked-border);
}

.hCNOVB:indeterminate ~ .VjAoa2 {
  display: none;
}

.hCNOVB:indeterminate::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 2px;
  background-color: white;
}

.YwkhSd {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--checkbox-label-color);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Checkbox/Checkbox.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;EACxC,4CAA4C;EAC5C,4CAA4C;EAC5C,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;EACpD,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,yCAAyC;EACzC,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,oDAAoD;EACpD,4CAA4C;AAC9C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,kCAAkC;AACpC","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n  cursor: pointer;\n  font-family: var(--font-family-base);\n}\n\n.container.disabled {\n  cursor: not-allowed;\n  opacity: var(--checkbox-disabled-opacity, 0.6);\n}\n\n.checkboxWrapper {\n  align-items: center;\n  display: flex;\n  height: 16px;\n  justify-content: center;\n  position: relative;\n  width: 16px;\n}\n\n.checkbox {\n  width: 16px;\n  height: 16px;\n  appearance: none;\n  border: 1px solid var(--checkbox-border);\n  border-radius: var(--checkbox-border-radius);\n  background-color: var(--checkbox-background);\n  cursor: pointer;\n  position: relative;\n}\n\n.checkbox:checked {\n  background-color: var(--checkbox-checked-background);\n  border-color: var(--checkbox-checked-border);\n}\n\n.checkIcon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: var(--checkbox-checked-icon-color);\n  display: none;\n  pointer-events: none;\n}\n\n.checkbox:checked ~ .checkIcon {\n  display: block;\n}\n\n.checkbox:disabled {\n  cursor: not-allowed;\n  opacity: var(--checkbox-disabled-opacity, 0.6);\n}\n\n.checkbox:indeterminate {\n  background-color: var(--checkbox-checked-background);\n  border-color: var(--checkbox-checked-border);\n}\n\n.checkbox:indeterminate ~ .checkIcon {\n  display: none;\n}\n\n.checkbox:indeterminate::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 8px;\n  height: 2px;\n  background-color: white;\n}\n\n.label {\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--checkbox-label-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `iW5e1i`,
	"disabled": `UMwjtk`,
	"checkboxWrapper": `jQygNX`,
	"checkbox": `hCNOVB`,
	"checkIcon": `VjAoa2`,
	"label": `YwkhSd`
};
module.exports = ___CSS_LOADER_EXPORT___;
